/* @flow */

import { ANIMATION_STEPS, CANVAS_WIDTH } from './constants';

export class Animation {
    currentValue: number;
    from: number;
    to: number;
    step: number;
    timeStamp: number;
    sign: number;
    k: number;
    constructor (from: number, to: number, minStep: number) {
        this.currentValue = from;
        this.to = to;
        this.from = to;
        this.timeStamp = Date.now();
        this.sign = to - from > 0 ? 1 : -1;
        this.step = minStep;
        this.k = (to - from);
    }
    getValue (): number {
        const timeDelta = Date.now() - this.timeStamp;
        this.timeStamp = Date.now();
        if ((this.to - this.currentValue) * this.sign > 0) {
            let delta = (this.k * timeDelta) / 100;
            this.currentValue += delta;
            return this.currentValue;
        } else {
            this.currentValue = this.to;
            return this.currentValue;
        }
    }
    finished (): boolean {
        return this.currentValue === this.to;
    }
}
